<template>
  <div class="flex flex-col p-6">
    <div v-if="!checking_subs">
      <div v-if="authorized">
        <p class="font-semibold text-xl border-b py-2 mb-4">
          <i class="fa fa-file text-brand"></i>
          Invoices
        </p>
        <div
          class="flex flex-col md:flex-row flex-wrap"
          v-if="invoices.length != 0"
        >
          <invoice
            v-for="invoice in invoices"
            :key="invoice.id"
            :invoice="invoice"
            :subscription-id="current_subscription.id"
            @view-payment="viewPayment"
            class="flex flex-col border rounded p-6 m-2"
          ></invoice>
        </div>

        <div
          class="bg-orange-lightest text-orange-dark p-4"
          role="alert"
          v-if="invoices.length == 0"
        >
          <p>No Invoice found</p>
        </div>
      </div>

      <div
        class="bg-orange-lightest text-orange-dark p-4 text-center w-full"
        role="alert"
        v-else
      >
        <p>
          Unable to view invoices because you do not have any subscriptions.
        </p>
      </div>
    </div>

    <div
      v-else
      class="w-full h-screen flex flex-col justify-center items-center"
    >
      <i class="fa fa-circle-notch fa-spin fa-3x"></i>
      <p class="mt-4">Please wait...</p>
    </div>

    <sweet-modal
      overlay-theme="dark"
      ref="view_payment"
      enable-mobile-fullscreen
    >
      <div class="text-left">
        <p class="py-2">
          <span class="font-semibold mr-2">Payment ID:</span>
          #{{ view_payment.id }}
        </p>
        <p class="py-2">
          <span class="font-semibold mr-2">Transaction Amount:</span>
          {{ view_payment.amount }}
        </p>
        <p class="py-2">
          <span class="font-semibold mr-2">Payment Message:</span>
          {{ view_payment.description }}
        </p>
        <p class="py-2">
          <span class="font-semibold mr-2">Date Settled:</span>
          {{ view_payment.time ? formatDate(view_payment.time) : '' }}
        </p>
      </div>
    </sweet-modal>

    <sweet-modal
      overlay-theme="dark"
      ref="view_payment"
      enable-mobile-fullscreen
    >
      <div class="text-left">
        <p class="py-2">
          <span class="font-semibold mr-2">Payment ID:</span>
          #{{ view_payment.id }}
        </p>
        <p class="py-2">
          <span class="font-semibold mr-2">Transaction Amount:</span>
          ${{ view_payment.amount }}
        </p>
        <p class="py-2">
          <span class="font-semibold mr-2">Payment Message:</span>
          {{ view_payment.description }}
        </p>
        <p class="py-2">
          <span class="font-semibold mr-2">Date Settled:</span>
          {{ view_payment.time ? formatDate(view_payment.time) : '' }}
        </p>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import Invoice from "./Invoice";

export default {
  components: {
    Invoice,
  },
  data() {
    return {
      invoices: "",
      current_subscription: "",
      view_payment: "",
      authorized: false,
      checking_subs: true,
    };
  },

  mounted() {
    this.getCurrentSubscription();
  },

  methods: {
    getCurrentSubscription() {
      axios.get("api/users/subscriptions").then(({ data }) => {
        this.checking_subs = false;
        let vault_id = this.$route.params.vault_id;

        this.current_subscription = _.find(data, function (subscription) {
          if(subscription.vault && subscription.vault.id) {
            return subscription.vault.id == vault_id;
          }
        });

        if (!_.isEmpty(this.current_subscription)) {
          this.authorized = true;
          this.getSubscriptionDetails();
        }
      });
    },

    getSubscriptionDetails() {
      axios
        .get(
          "api/users/subscriptions/" +
            this.current_subscription.id +
            "/invoices"
        )
        .then(({ data }) => {
          this.invoices = data;
        });
    },

    formatDate(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    },

    viewPayment(invoice_id) {
      axios
        .get(
          "api/users/subscriptions/" +
            this.current_subscription.id +
            "/invoices/" +
            invoice_id
        )
        .then(({ data }) => {
          this.view_payment = data.payments[0];
          this.$refs.view_payment.open();
        });
    },
  },
};
</script>

<style>
</style>